import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './components/auth/AuthContext'
import { PrivateRoute } from './components/auth/PrivateRoute'
import { CreatePasswordRoute } from './components/auth/CreatePasswordRoute'
import { ProgressGuard } from './components/auth/ProgressGuard'
import { OnboardingProvider } from './contexts/OnboardingContext'
import { LoginPage } from './pages/LoginPage'
import { CreatePasswordPage } from './pages/CreatePasswordPage'
import { ComponentExamplePage } from './pages/ComponentExamplePage'
import { ApplicationStartPage } from './pages/ApplicationStartPage'
import CompanyDataPage from './pages/CompanyDataPage'
import { CreditBureauConsultationPage } from './pages/CreditBureauConsultationPage'
import MajorityShareholderDataPage from './pages/MajorityShareholderDataPage'
import { PersonalCreditBureauConsultationPage } from './pages/PersonalCreditBureauConsultationPage'
import PersonalDataPage from './pages/PersonalDataPage'
import { DocumentsIndividualPage } from './pages/DocumentsIndividualPage'
import { FlowSelectionPage } from './pages/FlowSelectionPage'
import FlowTestPage from './pages/FlowTestPage'
import { GuarantorLoginRoute } from './pages/GuarantorLoginRoute'
import DynamicOnboardingStep from './components/onboarding/DynamicOnboardingStep'
import CiecConsultationPage from './pages/CiecConsultationPage'
import LegalRepresentativePage from './pages/LegalRepresentativePage'
import DocumentationPage from './pages/DocumentationPage'
import ScheduleVisitPage from './pages/ScheduleVisitPage'
import { ProposalReviewPage } from './pages/ProposalReviewPage'
import { InitialPaymentPage } from './pages/InitialPaymentPage'
import { ProposalStatusPage } from './pages/ProposalStatusPage'
import { ScheduleContractSigningPage } from './pages/ScheduleContractSigning'
import PendingProposalsRoute from './pages/PendingProposalsRoute'
import MyLeasesPage from './pages/MyLeasesPage'
import NewLeaseRequestPage from './pages/NewLeaseRequestPage'
import LeaseDetailPage from './pages/LeaseDetailPage'
import MyDocumentsPage from './pages/MyDocumentsPage'
import MyProfilePage from './pages/MyProfilePage'
import SettingsPage from './pages/SettingsPage'
import { OnboardingFinishedPage } from './pages/OnboardingFinishedPage'
import AcceptTermsConditionsModal from './components/onboarding/AcceptTermsConditionsModal'

function App() {
  return (
    <AuthProvider>
      <OnboardingProvider>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/aval/login" element={<GuarantorLoginRoute />} />
            <Route
              path="/create-password"
              element={
                <CreatePasswordRoute>
                  <CreatePasswordPage />
                </CreatePasswordRoute>
              }
            />

            {/* Test Page - Reemplaza Dashboard */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <FlowTestPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />

            {/* Test Page - Ruta alternativa */}
            <Route
              path="/test-flows"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <FlowTestPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />

            {/* =========================================
                SELECTOR DE FLUJO (INICIAL)
                ========================================= */}
            <Route
              path="/onboarding/flow-selection"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <FlowSelectionPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />

            <Route
              path="/onboarding/pending-proposals"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <PendingProposalsRoute />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />

            {/* =========================================
                MENÚ DE CUENTA (sidebar de "Mis cotizaciones")
                ========================================= */}
            <Route
              path="/mis-arrendamientos"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <MyLeasesPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/mis-arrendamientos/nuevo"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <NewLeaseRequestPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/mis-arrendamientos/:id"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <LeaseDetailPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/mis-documentos"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <MyDocumentsPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/mi-perfil"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <MyProfilePage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/configuracion"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <SettingsPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />

            {/* =================================
                RUTAS PERSONA MORAL (EMPRESAS) 
                ================================= */}
            {/* Rutas específicas de onboarding PM - deben ir ANTES de la ruta dinámica */}
            <Route
              path="/onboarding/ciec"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <CiecConsultationPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/onboarding/legal-representative"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <LegalRepresentativePage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/onboarding/documents"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <DocumentationPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/onboarding/schedule-visit"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <ScheduleVisitPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />

            {/* Ruta dinámica para todos los pasos de onboarding */}
            <Route
              path="/onboarding/*"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <DynamicOnboardingStep />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />

            {/* Rutas adicionales de PM */}
            <Route
              path="/onboarding/application-start"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <ApplicationStartPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/onboarding/company-data"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <CompanyDataPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/onboarding/credit-bureau-consultation"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <CreditBureauConsultationPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/onboarding/majority-shareholder-data"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <MajorityShareholderDataPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/onboarding/personal-credit-bureau-consultation"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <PersonalCreditBureauConsultationPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />

            {/* ===================================
                RUTAS PERSONA FÍSICA (INDIVIDUOS)
                =================================== */}
            {/* Paso 1: Application Start (compartido) ya definido arriba */}
            {/* Paso 2: CIEC consultation para PF */}
            <Route
              path="/onboarding/ciec-individual"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <CiecConsultationPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            {/* Paso 3: Datos personales */}
            <Route
              path="/onboarding/personal-data"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <PersonalDataPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/onboarding/documents-individual"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <DocumentsIndividualPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/onboarding/bureau-check-individual"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <PersonalCreditBureauConsultationPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/onboarding/schedule-visit-individual"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <ScheduleVisitPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />

            {/* ==========================================
                RUTAS COMUNES Y UTILIDADES
                ========================================== */}
            {/* Página de componentes */}
            <Route path="/components" element={<ComponentExamplePage />} />
            <Route
              path="/initial-payment"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <InitialPaymentPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/proposal-review"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <ProposalReviewPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/proposal-status"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <ProposalStatusPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
            <Route
              path="/schedule-contract-signing"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <ScheduleContractSigningPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />

            <Route
              path="/onboarding/finished"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <OnboardingFinishedPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />

            {/* Ruta de pago inicial - común para ambos flujos */}
            <Route
              path="/contract-signing"
              element={
                <PrivateRoute>
                  <ProgressGuard>
                    <InitialPaymentPage />
                  </ProgressGuard>
                </PrivateRoute>
              }
            />
          </Routes>
          <AcceptTermsConditionsModal />

          {/* Toast notifications - configuración mejorada */}
          <Toaster
            position="top-right"
            containerStyle={{
              top: 20,
              right: 20,
            }}
            toastOptions={{
              duration: 4000,
              style: {
                background: '#fff',
                color: '#363636',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                border: '1px solid #e5e7eb',
              },
              success: {
                duration: 3000,
                style: {
                  background: '#10B981',
                  color: '#fff',
                  border: 'none',
                },
              },
              error: {
                duration: 5000,
                style: {
                  background: '#EF4444',
                  color: '#fff',
                  border: 'none',
                },
              },
              loading: {
                style: {
                  background: '#3B82F6',
                  color: '#fff',
                  border: 'none',
                },
              },
            }}
          />
        </div>
      </OnboardingProvider>
    </AuthProvider>
  )
}

export default App
